import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, nextTick, onBeforeUnmount } from 'vue'
import { JtTableProps } from '@/components/JtTable/types'
import { MessageBox, Message } from 'element-ui'
import { IAsrApi } from '@/api/asr/type'
import { deleteResultApi, exportResultApi, getAsrResultList, getProgressAPI } from '@/api/asr/index'
import AsrResult from '../asrResult/index.vue'
import { convertToBrowserTimezone, downloadFile } from '@/utils'
import { PageReqSchema } from '@/types/axios/public-json-structure'
import { StorageDaysModule } from '@/store/modules/storage-days'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const jtTableRef = ref()

// 表头
const tableConfig: JtTableProps.ColumnConfig[] = [
  {
    label: '名称',
    prop: 'name',
    isSlot: true
  },
  {
    label: '创建时间',
    prop: 'createDt',
    elColProps: {
      formatter(row: IAsrApi.IListItem) {
        if (row.createDt) {
          return convertToBrowserTimezone(row.createDt)
        } else {
          return '-'
        }
      }
    }
  },
  {
    label: '类别',
    prop: 'recordType',
    elColProps:{
      formatter(row:IAsrApi.IListItem){
        const val = row.recordType
        if(!(val in IAsrApi.recordTypeEnum)){
          return '-'
        }
        return IAsrApi.recordTypeMap[val]
      }
    }  },
  {
    label: '状态',
    prop: 'status',
    isSlot: true
  },
  {
    label: '操作',
    prop: 'handle',
    isSlot: true,
    elColProps: {
      align: 'left',
      width: '120',
    }
  }
]
let timers: number | undefined
const tableData = ref<IAsrApi.IListItem[]>([])
async function tableApi(page: PageReqSchema) {
  // 清空勾选
  nextTick(() => {
    selectData.value = []
  })
  try {
    let res = await getAsrResultList(page)
    tableData.value = res.data
    loopGetProgress(tableData.value)
    return res
  } catch (error) {
    error
  }
}
// 轮询查询进度
function loopGetProgress(data:IAsrApi.IListItem[]) {
  let idArray: string[] = []
  timers && clearInterval(timers)
  timers = window.setInterval(() => {
    idArray = []
    const filterArray = data.filter((t:IAsrApi.IListItem) => t.status != IAsrApi.taskStatusEnum.Done && t.status != IAsrApi.taskStatusEnum.Fail)
    idArray.push(...filterArray.map((t: IAsrApi.IListItem) => t.id))
    if (!idArray.length) {
      clearInterval(timers)
      timers = undefined
    } else {
      getProgress(idArray)
      // 更新识别进度及状态
      jtTableRef.value?.updateTableData(tableData.value)
    }
  }, 2000)
}

// 根据ids获取当前页待识别和识别中item的最新状态与进度
async function getProgress (ids: string[]) {
  if (!ids.length) return
  const { data } = await getProgressAPI({ id: ids.join(',') })
  tableData.value?.forEach(t => {
    data.some((f) => {
      if (f.id === t.id) {
        t.progress = Number(f.progress)
        t.status = f.status
      }
    })
  })
}
// 根据状态排序
function sortByState (data: IAsrApi.IListItem[]) {
  const order: IAsrApi.taskStatusEnum[] = [
    IAsrApi.taskStatusEnum.Working,
    IAsrApi.taskStatusEnum.Doing,
    IAsrApi.taskStatusEnum.Fail,
    IAsrApi.taskStatusEnum.Loading,
    IAsrApi.taskStatusEnum.Done
  ]
  const target: IAsrApi.IListItem[] = []
  order.forEach((status) => {
    const sortArray = data.filter(t => t.status === status).sort((a, b) => {
      return handleTimeSort(b.createDt, a.createDt)
    })
    if (sortArray.length) {
      target.push(...sortArray)
    }
  })
  return target
}
function handleTimeSort (t1: string, t2: string) {
  return Number(new Date(t1).getTime()) - Number(new Date(t2).getTime())
}
onBeforeUnmount(() => {
  clearInterval(timers)
})
function getStateTitle (status: IAsrApi.taskStatusEnum) {
  return IAsrApi.taskStateMap[status]
}

const checkboxConfig = {
  // 仅完成状态的条目可勾选
  selectable: (row: IAsrApi.IListItem) => {
    return row.status === IAsrApi.taskStatusEnum.Done
  }
}

const selectData = ref<IAsrApi.IListItem[]>([])
function selectChange (data: IAsrApi.IListItem[]) {
  selectData.value = data
}


// 删除任务
function handleDelTask(t: IAsrApi.IListItem[]){
  MessageBox.confirm('删除后不可恢复，请确认', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    let ids = t.map(i => i.id)
    await deleteResultApi(ids)
    Message.success('删除成功!')
    jtTableRef.value?.refreshCurrent()
  }).catch(() => {})
}

function handleSelectExportCommand(command:string, ) {
  if (command == 'docx') {
    handleSelectExport(selectData.value, IAsrApi.EnumExportType.Docx)
  } else if (command === 'all') {
    handleSelectExport(selectData.value, IAsrApi.EnumExportType.All)
  }
}
function commandValue(command: string, row: IAsrApi.IListItem) {
  return {
    'command': command,
    'row': row
  }
}
function handleItemExportCommand(item: { command:string, row: IAsrApi.IListItem }) {
  const { command, row } = item
  if (command == 'docx') {
    handleItemExport(row, IAsrApi.EnumExportType.Docx)
  } else if (command === 'all') {
    handleItemExport(row, IAsrApi.EnumExportType.All)
  }
}
/**
 * asr导出相关逻辑：
 * 1. 单条导出时，分别导出文本与音频文件，调用两次接口
 *    EnumExportType.Docx EnumExportType.Audio）
 *
 * 2. 批量导出时，如果只有一条则还是走单条导出的逻辑，两条或以上的导出结果为
 *    文本与音频的压缩包，调用一次接口（EnumExportType.All）
 */

// 导出
async function handleItemExport(row: IAsrApi.IListItem, type: IAsrApi.EnumExportType) {
  if (type === IAsrApi.EnumExportType.All) {
    await exportResultApi(row.id, IAsrApi.EnumExportType.Docx)
      .then(downloadFile)
      .catch(err => {
        Message.error('导出失败:' + err.message)
      })

    await exportResultApi(row.id, IAsrApi.EnumExportType.Audio)
      .then(downloadFile)
      .catch(err => {
        Message.error('导出失败:' + err.message)
      })
  } else {
    try {
      await exportResultApi(row.id, IAsrApi.EnumExportType.Docx)
        .then(downloadFile)
        .catch(err => {
          Message.error('导出失败:' + err.message)
        })
    } catch (error) {
      error
    }
  }
}
// 批量导出
async function handleSelectExport(rows: IAsrApi.IListItem[],type: IAsrApi.EnumExportType){
  if (rows.length === 0) {
    return
  } else if (rows.length === 1) {
    handleItemExport(rows[0], type)
  } else {
    const ids = selectData.value.map(t => t.id).join(',')
    try {
      btnLoading.export = true
      await exportResultApi(ids, type)
        .then(downloadFile)
        .catch(err => {
          Message.error('导出失败:' + err.message)
        })
    } catch (error) {
      error
    } finally {
      btnLoading.export = false
    }
  }
}


const btnLoading = reactive({
  import: false,
  export: false,
  downloadTemplate: false,
})

const isShowRes = ref(false)
const fileId = ref('')
function handleBackTo (id?: string,) {
  if (id) {
    // 跳转到识别结果
    fileId.value = id
    isShowRes.value = true
  } else {
    // 跳转到识别列表
    isShowRes.value = false
  }
}
function handleShowResult (item: IAsrApi.IListItem) {
  if (item.status !== IAsrApi.taskStatusEnum.Done) return
  handleBackTo(item.id)
}

return { __sfc: true,jtTableRef, tableConfig, timers, tableData, tableApi, loopGetProgress, getProgress, sortByState, handleTimeSort, getStateTitle, checkboxConfig, selectData, selectChange, handleDelTask, handleSelectExportCommand, commandValue, handleItemExportCommand, handleItemExport, handleSelectExport, btnLoading, isShowRes, fileId, handleBackTo, handleShowResult, IAsrApi, AsrResult, StorageDaysModule }
}

})